import { render, staticRenderFns } from "./RulesConductPage.vue?vue&type=template&id=72b0f933&"
import script from "./RulesConductPage.vue?vue&type=script&lang=js&"
export * from "./RulesConductPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports